/**
 * BilingualBadge — the "ENGLISH + తెలుగు" language pill used everywhere a
 * customer needs an instant, unmissable signal that a Chinnu title is a
 * bilingual English–Telugu edition (series hero, product cards, PDPs,
 * bundle page, pre-buy context).
 */
export default function BilingualBadge({ dark = false, compact = false, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-bold uppercase tracking-[0.1em] whitespace-nowrap ${
        compact ? "px-2.5 py-1 text-[10px]" : "px-3.5 py-1.5 text-[11px] sm:text-[12px]"
      } ${
        dark
          ? "bg-white/10 text-white border-white/30"
          : "bg-[#004D40]/[0.08] text-[#004D40] border-[#004D40]/25"
      }`}
    >
      English <span className="opacity-70">+</span>{" "}
      <span className="font-telugu text-[1.15em] normal-case">తెలుగు</span>
    </span>
  );
}
